import React, { useState, useEffect } from "react";


function PackagesPage({ packages, setPackages }) {



    return (

        <section className="space-y-3 mt-6">
            <h3 className="text-lg font-semibold flex justify-between items-center">
                Packages
                <button
                    type="button"
                    onClick={() =>
                        setPackages([
                            ...packages,
                            {
                                package_name: "",
                                lunch_type: "",
                                duration_hours: "",
                                original_price: "",
                                offer_price: "",
                                currency: "INR",
                                includes_activities: false,
                                activity_count: 0,
                                is_active: true,
                            },
                        ])
                    }
                    className="text-sm px-2 py-1 bg-gray-100 rounded"
                >
                    +
                </button>
            </h3>

            {packages.map((p, i) => (
                <>
                    <div
                        key={i}
                        className="grid grid-cols-1 md:grid-cols-4 gap-3 border p-3 rounded"
                    >
                        {/* Package Name */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs text-gray-500">Package Name</label>
                            <input
                                type="text"
                                className="p-2 border rounded"
                                value={p.package_name}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? { ...item, package_name: e.target.value }
                                                : item
                                        )
                                    )
                                }
                            />
                        </div>

                        {/* Lunch Type */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs text-gray-500">Lunch Type</label>
                            <select
                                className="p-2 border rounded"
                                value={p.lunch_type}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? { ...item, lunch_type: e.target.value }
                                                : item
                                        )
                                    )
                                }
                            >
                                <option value="">Select</option>
                                <option value="Indian Only">Indian Only</option>
                                <option value="Thai">Thai</option>
                                <option value="Included">Included</option>
                            </select>
                        </div>

                        {/* Duration */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs text-gray-500">Duration (Hours)</label>
                            <input
                                type="number"
                                className="p-2 border rounded"
                                value={p.duration_hours}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? { ...item, duration_hours: e.target.value }
                                                : item
                                        )
                                    )
                                }
                            />
                        </div>

                        {/* Currency */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs text-gray-500">Currency</label>
                            <select
                                className="p-2 border rounded"
                                value={p.currency}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? { ...item, currency: e.target.value }
                                                : item
                                        )
                                    )
                                }
                            >
                                <option value="INR">INR</option>
                                <option value="THB">THB</option>
                                <option value="USD">USD</option>
                            </select>
                        </div>

                        {/* Original Price */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs text-gray-500">Original Price</label>
                            <input
                                type="number"
                                className="p-2 border rounded"
                                value={p.original_price}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? { ...item, original_price: e.target.value }
                                                : item
                                        )
                                    )
                                }
                            />
                        </div>

                        {/* Offer Price */}
                        <div className="flex flex-col gap-1">
                            <label className="text-xs text-gray-500">Offer Price</label>
                            <input
                                type="number"
                                className="p-2 border rounded"
                                value={p.offer_price}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? { ...item, offer_price: e.target.value }
                                                : item
                                        )
                                    )
                                }
                            />
                        </div>

                        {/* Includes Activities */}
                        <label className="flex items-center gap-2 mt-5 text-sm">
                            <input
                                type="checkbox"
                                checked={p.includes_activities}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? {
                                                    ...item,
                                                    includes_activities: e.target.checked,
                                                }
                                                : item
                                        )
                                    )
                                }
                            />
                            Includes Activities
                        </label>

                        {/* Activity Count */}
                        {p.includes_activities && (
                            <div className="flex flex-col gap-1">
                                <label className="text-xs text-gray-500">
                                    Activity Count
                                </label>
                                <input
                                    type="number"
                                    className="p-2 border rounded"
                                    value={p.activity_count}
                                    onChange={(e) =>
                                        setPackages(
                                            packages.map((item, idx) =>
                                                idx === i
                                                    ? {
                                                        ...item,
                                                        activity_count: e.target.value,
                                                    }
                                                    : item
                                            )
                                        )
                                    }
                                />
                            </div>
                        )}

                        {/* Active */}
                        <label className="flex items-center gap-2 mt-5 text-sm">
                            <input
                                type="checkbox"
                                checked={p.is_active}
                                onChange={(e) =>
                                    setPackages(
                                        packages.map((item, idx) =>
                                            idx === i
                                                ? { ...item, is_active: e.target.checked }
                                                : item
                                        )
                                    )
                                }
                            />
                            Active
                        </label>

                        {/* Remove */}
                        {i > 0 && (
                            <button
                                type="button"
                                onClick={() =>
                                    setPackages(packages.filter((_, idx) => idx !== i))
                                }
                                className="text-red-600 text-sm mt-5"
                            >
                                Remove
                            </button>
                        )}
                    </div>





            

                </>

            ))}
        </section>
    )
}

export default PackagesPage